export default __webpack_public_path__ + "static/media/Ervins.7b466645.png";